<template>
  <div
    :class="{
      'border border-gray-400 bg-white rounded p-6': !isChild
    }"
  >
    <div v-if="!isChild" class="flex items-center justify-between pb-6">
      <h3 class="text-lg font-medium text-gray-900">{{ title }}</h3>
      <MainButton v-if="editable" title="Edit" blue small @click="edit" />
    </div>

    <dl>
      <div v-for="(field, i) in form" :key="i">
        <div
          v-if="field.value"
          class="grid grid-cols-1 sm:grid-cols-3 col-gap-10 py-6 border-t border-gray-400 hover:bg-gray-200 duration-100"
        >
          <dt
            class="text-sm break-words leading-5 font-medium text-gray-700 mb-2 sm:mb-0"
          >
            <p>{{ field.label }}</p>
          </dt>

          <dd class="col-span-2 text-sm leading-5 text-gray-900">
            {{ getValue(field.value) }}
            <p v-for="(val, idx) in field.value" :key="idx">
              {{ val.originalFileName }}
            </p>
          </dd>
        </div>
      </div>

      <div
        v-if="supportingDocuments && supportingDocuments.length > 0"
        class="grid grid-cols-1 sm:grid-cols-3 col-gap-10 py-6 border-t border-gray-400 hover:bg-gray-200 duration-100"
      >
        <dt
          class="text-sm break-words leading-5 font-medium text-gray-700 mb-2 sm:mb-0"
        >
          <p>Supporting Documents</p>
        </dt>

        <dd class="col-span-2 text-sm leading-5 text-gray-900">
          <p v-for="(doc, i) in supportingDocuments" :key="i">
            {{ doc.originalFileName }}
          </p>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'FormSummary',
  props: {
    title: {
      type: String,
      default: null
    },
    form: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    },
    parentValue: {
      type: undefined,
      default: null
    },
    isChild: {
      type: Boolean,
      default: false
    },
    compensations: {
      type: Array,
      default: null
    },
    supportingDocuments: {
      type: Array,
      default: null
    }
  },
  methods: {
    edit() {
      const bank = 'bank-details';
      const claim = 'provide-information';

      this.$router.push(this.title === 'Bank Details' ? bank : claim);

      this.scrollToTop();
    },
    getValue(value) {
      if (!value) {
        return '';
      } else if (
        Object.prototype.toString.call(value) !== '[object String]' &&
        !value.label
      ) {
        return '';
      }

      return value.label ? value.label : value;
    }
  }
};
</script>
